var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3640_9878)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3640_9878",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.763672,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3640_9878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2129 22.7637L8.81489 19.5637C8.5993 19.4803 8.39632 19.3803 8.20594 19.2637C8.01489 19.147 7.82816 19.022 7.64574 18.8887L4.68554 20.1387L1.94922 15.3887L4.51141 13.4387C4.49482 13.322 4.48653 13.2093 4.48653 13.1007V12.4257C4.48653 12.3177 4.49482 12.2053 4.51141 12.0887L1.94922 10.1387L4.68554 5.38867L7.64574 6.63867C7.82816 6.50534 8.01887 6.38034 8.21788 6.26367C8.41688 6.14701 8.61589 6.04701 8.81489 5.96367L9.2129 2.76367H14.6855L15.0835 5.96367C15.2991 6.04701 15.5025 6.14701 15.6935 6.26367C15.8839 6.38034 16.0703 6.50534 16.2527 6.63867L19.2129 5.38867L21.9492 10.1387L19.387 12.0887C19.4036 12.2053 19.4119 12.3177 19.4119 12.4257V13.1007C19.4119 13.2093 19.3953 13.322 19.3622 13.4387L21.9243 15.3887L19.188 20.1387L16.2527 18.8887C16.0703 19.022 15.8796 19.147 15.6806 19.2637C15.4816 19.3803 15.2826 19.4803 15.0835 19.5637L14.6855 22.7637H9.2129ZM11.999 16.2637C12.9608 16.2637 13.7817 15.922 14.4617 15.2387C15.1416 14.5553 15.4816 13.7303 15.4816 12.7637C15.4816 11.797 15.1416 10.972 14.4617 10.2887C13.7817 9.60534 12.9608 9.26367 11.999 9.26367C11.0205 9.26367 10.1953 9.60534 9.52335 10.2887C8.85204 10.972 8.51638 11.797 8.51638 12.7637C8.51638 13.7303 8.85204 14.5553 9.52335 15.2387C10.1953 15.922 11.0205 16.2637 11.999 16.2637Z",
    fill: "#6E6E6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3640_9878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.763672)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.ec22da90bbffd0d3d04fa20eccfdc20d.svg";
export { ForwardRef as ReactComponent };